module.exports = __webpack_public_path__ + "static/media/code.f90e8ebe.svg";